import { connect } from 'react-redux';
import { Subscribe } from 'unstated';

import { mapDispatchToProps, mapStateToProps, ProductCardContainer } from 'Component/ProductCard/ProductCard.container';
import SharedTransitionContainer from 'Component/SharedTransition/SharedTransition.unstated';

import ProductCardWishlist from './ProductCardWishlist.component';

export { mapDispatchToProps, mapStateToProps };
/** @namespace Pwa/Component/ProductCardWishlist/Container */
export class ProductCardWishlistContainer extends ProductCardContainer {
    containerProps() {
        const { removeButton } = this.props;

        return { ...super.containerProps(), removeButton };
    }

    render() {
        return (
            <Subscribe to={[SharedTransitionContainer]}>
                {({ registerSharedElement }) => (
                    <ProductCardWishlist
                        {...this.containerFunctions}
                        {...this.containerProps()}
                        registerSharedElement={registerSharedElement}
                    />
                )}
            </Subscribe>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductCardWishlistContainer);
